import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';

import {ShoppingService} from '@app/shopping/shopping.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {AuthenticationService} from '@app/core';
import {ShoppingModel} from '../../models/shopping.model';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {AngularFireDatabase} from 'angularfire2/database';
import {UtilityService} from '../core/utils.service';
import {DomainService} from '@app/core/domain/domain.service';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  registerContentSucess: any;
  registerContentError: any;
  hash: string;
  hash2: string;
  quote: string;
  citySelect: ShoppingModel;
  districtSelect: ShoppingModel;
  townSelect: ShoppingModel;
  isLoading: boolean;
  isShoppingDomain: boolean;
  shoppingsList: ShoppingModel[] = [];
  shoppings: ShoppingModel[] = [];
  listDistrict: ShoppingModel[];
  listCity: ShoppingModel[];
  listTown: ShoppingModel[];
  filter: ShoppingModel = new ShoppingModel();
  modalReference: NgbModalRef;
  placeService: PlaceServiceBase;

  constructor(private shoppingService: ShoppingService,
              private chainService: ChainService,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService,
              private modalService: NgbModal,
              private util: UtilityService,
              private domainService: DomainService) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.util.setBarBackground();
    this.util.setBarTextColor();
  }

  ngOnInit() {

    this.hash = this.route.snapshot.paramMap.get('hash');
    this.hash2 = this.route.snapshot.paramMap.get('hash2');

    if (this.hash) {
        this.authenticationService.confirmRegister(this.hash)
          .pipe(finalize(() => {
            this.router.navigate(['/'], { replaceUrl: true });
          }))
          .subscribe(credentials => {
            this.openModalSucess();
          }, error => {
            this.openModalError();
          });
    }

    if (this.hash2) {
      this.authenticationService.confirmLogin(this.hash2)
        .pipe(finalize(() => {
          this.router.navigate(['/'], { replaceUrl: true });
        }))
        .subscribe(credentials => {
          this.openModalSucess();
        }, error => {
          this.openModalError();
        });
    }

    this.loadShoppings();

    this.filter = new ShoppingModel();
    this.filter.town = 'Bairro';
    this.filter.city = 'Cidade';
    this.filter.district = 'Estado';
    this.townSelect = this.filter;
    this.citySelect = this.filter;
    this.districtSelect = this.filter;

    this.listDistrict = [];
    this.listDistrict.push(this.filter);

    this.listCity = [];
    this.listCity.push(this.filter);

    this.listTown = [];
    this.listTown.push(this.filter);

    this.loadDistric();
    this.loadCity();
    this.loadTown();
  }

  loadShoppings() {
    this.isLoading = true;
    let getShoppings = this.placeService.get();
    if (this.authenticationService.credentials != null) {
        getShoppings = this.placeService.getPrivate();
    }

    getShoppings.pipe(finalize(() => {
      this.isLoading = false;
    }))
    .subscribe(shoppings => {
      this.shoppings = shoppings;
      this.shoppingsList = shoppings;
    }, error => {
      console.log(`shopping error: ${error}`);
    });
  }

  loadDistric() {
    this.placeService.getListDistrict()
      .pipe(finalize(() => {
      }))
      .subscribe(resp => {
        this.listDistrict = this.listDistrict.concat(resp);
      }, error => {
        console.log(`Disctrict error: ${error}`);
      });

  }

  loadCity() {
    this.placeService.getListCity()
      .pipe(finalize(() => {
      }))
      .subscribe(resp => {
        this.listCity = this.listCity.concat(resp);
      }, error => {
        console.log(`City error: ${error}`);
      });
  }

  loadTown() {
    this.placeService.getListTown()
      .pipe(finalize(() => {
      }))
      .subscribe(resp => {
        this.listTown = this.listTown.concat(resp);
      }, error => {
        console.log(`Town error: ${error}`);
      });
  }

  openShopping(shopping: ShoppingModel) {
    this.router.navigate(['/shopping/[id]/promotions'.replace('[id]', shopping.id_hash)]);
  }

  navbarLeftText() {
    return `Exibindo ${this.shoppings.length} ${this.isShoppingDomain ? 'Shoppings' : 'Redes'}`;
  }

  applyFilter() {
    this.shoppings = this.shoppingsList;

    if (this.filter && this.filter.name && this.filter.name.length > 0) {
      this.shoppings = this.shoppings
        .filter((item) => item.name.toLowerCase().indexOf(this.filter.name.toLowerCase()) !== -1);
    }

    if (this.townSelect && this.townSelect.town !== this.listTown[0].town) {
      this.shoppings = this.shoppings
        .filter((item) => {
        if (!item.town) {
          return false;
        }
        return item.town.toLowerCase() === this.townSelect.town.toLowerCase();
      });
    }

    if (this.citySelect && this.citySelect.city !== this.listCity[0].city) {
      this.shoppings = this.shoppings
        .filter((item) => {
          if (!item.city) {
            return false;
          }
          return item.city.toLowerCase() === this.citySelect.city.toLowerCase();
        });
    }

    if (this.districtSelect && this.districtSelect.district !== this.listDistrict[0].district) {
      this.shoppings = this.shoppings
        .filter((item) => {
          if (!item.district) {
            return false;
          }
          return item.district.toLowerCase() === this.districtSelect.district.toLowerCase();
        });
    }

  }

  setContentSucess(content:any): boolean {
    this.registerContentSucess = content;
    return true;
  }

  setContentError(content:any): boolean {
    this.registerContentError = content;
    return true;
  }

  openModalSucess() {
    this.modalReference = this.modalService.open(this.registerContentSucess, { windowClass: 'modal-centered modal-md' });
  }

  openModalError() {
    this.modalReference = this.modalService.open(this.registerContentError, { windowClass: 'modal-centered modal-md' });
  }




}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/home/home.component.ts